import { createRouter, createWebHashHistory } from 'vue-router';  
import LoginForm from '../components/LoginForm.vue';  
import HomePage from '../components/HomePage.vue';  
import update from '../components/update.vue';  
import search_std from '../components/search_std.vue';  
import applog_info from '../components/applog_info.vue';  
import logout from '../components/logout.vue';  
import admin_info from '../components/admin_info.vue';  
import template_updata from '../components/template_updata.vue';  
import Advanced_Operations from '../components/Advanced_Operations.vue';  

const routes = [
  { path: '/login', component: LoginForm },
  {
    path: '/',
    component: HomePage,
    meta: { requireLogin: true },
    children: [
      { path: '/update', component: update },
      { path: '/search', component: search_std },
      { path: '/applog', component: applog_info },
      { path: '/logout', component: logout },
      { path: '/adminlog', component: admin_info },
      { path: '/template_updata', component: template_updata },
      { path: '/Advanced_Operations', component: Advanced_Operations }
    ]
  }
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL), // 这里更改为使用哈希模式
  routes
});

export default router;